<template>
  <!-- <router-link to="/tryout-groups" tag="li"><a><i class="fa fa-pencil"></i><span>Tryout Group</span></a></router-link> -->
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-pencil"></i>
      <span>Tryout</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/tryouts">Tryout</router-link></li>
      <li><router-link to="/tryout-groups">Tryout Group</router-link></li>
      <li><router-link to="/serial">Tryout Serial</router-link></li>
      <li><router-link to="/tryout-regrading">Regrading Tryout</router-link></li>
    </ul>
  </li>
</template>

<script>
import itembankService from '@/services/itembank.js'

export default {
  name: 'itembank-nav',
  components: {
  },
  data: function() {
    return {items: []}
  },
  mounted: function() {

  }
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?2cc25761